module.exports = __webpack_public_path__ + "static/media/banner2.308c1688.png";